/* ═════════════════════════════════════════════════════════════════════════════
   SRC/COMPONENTS/TABJOURNEYVIEW/JOURNEYREFERENCE.JS — meta e Sist. Unimed da etapa
   ─────────────────────────────────────────────────────────────────────────────
   Quando a linha da etapa vinha sem unimed_system ou target, a aba Jornada
   caía em JCFG (_shared.jsx) — valores fixos de mock (Sist. Unimed 42–76,
   meta 62–85) exibidos como se fossem o benchmark e a meta reais do cliente.
   Sem dado, a tela mostra "—"; nunca um número inventado. Meta 0 é o que o
   pipeline grava para cliente sem meta cadastrada, então também vira null
   (e "-" na tela, via formatMeta).
   ═══════════════════════════════════════════════════════════════════════════ */

import { metaDefinida } from "../../utils/meta";

const valorOuNulo = (valor) => {
  if (valor === null || valor === undefined || valor === "") return null;
  const n = Number(valor);
  return Number.isFinite(n) ? n : null;
};

/**
 * Meta e benchmark do Sistema Unimed de uma etapa, só a partir da API.
 * @param {object} etapa - linha de state.dashboard.journey
 * @returns {{meta: number|null, sys: number|null}}
 */
export function journeyStageReference(etapa = {}) {
  return {
    meta: metaDefinida(etapa?.target),
    sys: valorOuNulo(etapa?.unimed_system),
  };
}

/**
 * Id da métrica da etapa selecionada — é por ele que a Jornada busca os
 * verbatins (GET /verbatins?fk_id_metric=). A linha vem de
 * state.dashboard.journey, que já é buscada no recorte filtrado (período,
 * cidade, segmento NPS, vínculo): cada recorte é um period próprio, com
 * métricas e verbatins próprios, então os verbatins seguem o filtro por
 * construção. Não troque por uma busca de /verbatins sem fk_id_metric:
 * ela devolve os verbatins da empresa inteira, de qualquer recorte.
 * @param {object[]} journey - linhas de state.dashboard.journey
 * @param {string|null} etapa - nome da etapa selecionada
 * @returns {number|null}
 */
export function metricIdDaEtapa(journey = [], etapa = null) {
  if (!etapa) return null;
  const linha = journey.find((e) => e.name === etapa);
  return linha?.id || linha?.fk_id_metric || linha?.metric?.id || null;
}
